// extracted by mini-css-extract-plugin
export var ApiResponseCodeBlock = "ApiResponseCodeBlock-module--ApiResponseCodeBlock--rG5xt";
export var Header = "ApiResponseCodeBlock-module--Header--1pBbO";